import { render } from "./StadiumComponent.vue?vue&type=template&id=cf0dca9c&scoped=true&ts=true"
import script from "./StadiumComponent.vue?vue&type=script&lang=ts"
export * from "./StadiumComponent.vue?vue&type=script&lang=ts"

import "./StadiumComponent.vue?vue&type=style&index=0&id=cf0dca9c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src903112286/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0dca9c"]])

export default __exports__